import {API} from 'aws-amplify';
import axios from 'axios';
import querystring from 'querystring';

const myApi = axios.create({
  baseURL: 'https://newsletter.ihrespezialisten.at/api/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

// @ts-ignore
export const create = (one) => API.put('ihrespezialistenBackend', '/articles', {body: one});

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/articles', {});

// @ts-ignore
export const readOne = (id) => API.get('ihrespezialistenBackend', `/articles/${id}`, {});

// @ts-ignore
export const update = (one) => API.post('ihrespezialistenBackend', `/articles/${one.id}`, {body: one});

// @ts-ignore
export const remove = (id) => API.del('ihrespezialistenBackend', `/articles/${id}`, {});

// @ts-ignore
export const articleClickedBy = async (article) => {
  const result = await myApi.post('subscribers/url_click_statistic_by_user.php', querystring.stringify({
    api_key: 'Ax1exQ4SnVQsv6A1xmkQ',
    article_id: article.id,
  }));

  return result;
};
